module.exports = __webpack_public_path__ + "static/media/cdcuenta.45f56f72.jpg";